module.exports = __webpack_public_path__ + "img/AD.51e76a71.svg";